module.exports = __webpack_public_path__ + "img/HEART-A.45aecce6.svg";